"use client";
import { selfPromotionEvent } from "@/lib/atInternetTags";
import type { TravelList, TravelListItem } from "@/queries/getTravelList";
import { useRouter } from "next/navigation";
import { type MouseEvent, type ReactNode, useEffect } from "react";
import { useInView } from "react-intersection-observer";

type Props = {
  travelList: TravelList;
  travel: TravelListItem["travel"];
  departure: NonNullable<TravelListItem["departure"]>;
  position: number;
  children: ReactNode;
};
export const Container = ({ travelList, travel, departure, position, children }: Props) => {
  const router = useRouter();
  const { ref, inView } = useInView({
    rootMargin: "500px",
    triggerOnce: true,
  });

  useEffect(() => {
    if (!departure) return;

    if (inView) {
      // TODO est ce qu'on a besoin de tous ces champs ?
      // productEvent({
      //   event: "product.display",
      //   product_id: travel.id.toString(),
      //   product: travel.alias || undefined,
      //   product_variant: travel.travelTypeId,
      //   product_brand: travel.brandTitle || undefined,
      //   product_discount: travel.departure.primoPrice !== undefined,
      //   product_pricetaxincluded: travel.departure.primoPrice
      //     ? travel.departure.defaultPrice - travel.departure.primoPrice
      //     : travel.departure.defaultPrice,
      //   product_category1: travel.destinations[0]?.alias || "",
      //   product_category2: travel.destinations[1]?.alias || "",
      //   product_currency: "EUR",
      //   speaker_ids: travel.departure.speakers.map((speaker) => speaker.id.toString()),
      //   registration_status: travel.departure.registrationStatus,
      //   travel_duration: travel.departure.days || undefined,
      // });

      selfPromotionEvent({
        event: "self_promotion.display",
        onsitead_position: position,
        onsitead_type: "Self promotion",
        onsitead_category: "top_travel",
        product_id: travel.id.toString(),
        departure_id: departure.id.toString(),
      });
    }
  }, [inView, travel, departure, position]);

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    selfPromotionEvent({
      event: "self_promotion.click",
      onsitead_position: position,
      onsitead_type: "Self promotion",
      onsitead_category: "top_travel",
      product_id: travel.id.toString(),
      departure_id: departure.id.toString(),
    });
    router.push(`/voyage/${travel.alias}-${travel.id}/${departure.id}/`);
  };

  return (
    <div ref={ref} onClick={handleClick}>
      {children}
    </div>
  );
};
